import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MapPin = ({
  height = 16,
  width = 16,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 16 16" {...props}>
    <path
      d="M5.5 5.5C5.5 6.16304 5.76339 6.79893 6.23223 7.26777C6.70107 7.73661 7.33696 8 8 8C8.66304 8 9.29893 7.73661 9.76777 7.26777C10.2366 6.79893 10.5 6.16304 10.5 5.5C10.5 4.83696 10.2366 4.20107 9.76777 3.73223C9.29893 3.26339 8.66304 3 8 3C7.33696 3 6.70107 3.26339 6.23223 3.73223C5.76339 4.20107 5.5 4.83696 5.5 5.5Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 0.5C9.32608 0.5 10.5979 1.02678 11.5355 1.96447C12.4732 2.90215 13 4.17392 13 5.5C13 7.77133 9.61733 13.4667 8.41667 15.2767C8.37106 15.3454 8.30914 15.4018 8.23644 15.4408C8.16374 15.4799 8.08251 15.5003 8 15.5003C7.91749 15.5003 7.83626 15.4799 7.76356 15.4408C7.69086 15.4018 7.62894 15.3454 7.58333 15.2767C6.38267 13.4667 3 7.77133 3 5.5C3 4.17392 3.52678 2.90215 4.46447 1.96447C5.40215 1.02678 6.67392 0.5 8 0.5V0.5Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
